// Leave and unavailability register.
import React from 'react';
import { RegisterPage, FieldSpec, useLookup, dateCol } from '../crud';
import { StatusChip } from '../ui';

const LEAVE_TYPES = ['Annual leave', 'Personal leave', 'RDO', 'Public holiday', 'Training', 'Unavailable', 'Other'];

export default function Leave() {
  const people = useLookup('people');
  const specs: FieldSpec[] = [
    { name: 'person_id', label: 'Person', type: 'select', lookup: 'people', required: true },
    { name: 'leave_type', label: 'Leave type', type: 'select', options: LEAVE_TYPES, required: true, default: 'Annual leave' },
    { name: 'start_date', label: 'Start date', type: 'date', required: true },
    { name: 'end_date', label: 'End date', type: 'date', required: true },
    { name: 'approval_status', label: 'Approval status', type: 'select', options: ['requested', 'approved', 'declined'], default: 'requested' },
    { name: 'notes', label: 'Notes', type: 'textarea' }
  ];
  return (
    <RegisterPage
      title="Leave & unavailability"
      entity="leave"
      specs={specs}
      lookupEntities={{ people }}
      columns={[
        { key: 'person_id', label: 'Person', render: r => <strong>{people.byId[r.person_id] || r.person_id}</strong>, sortValue: r => people.byId[r.person_id] },
        { key: 'leave_type', label: 'Type' },
        dateCol('start_date', 'Start'),
        dateCol('end_date', 'End'),
        { key: 'approval_status', label: 'Approval', render: r => <StatusChip status={r.approval_status === 'approved' ? 'confirmed' : r.approval_status === 'declined' ? 'cancelled' : 'tentative'} />, sortValue: r => r.approval_status },
        { key: 'notes', label: 'Notes' }
      ]}
    />
  );
}
